import { connect } from 'react-redux'
import ErrorBar from '../components/ui/ErrorBar'
import { IStoreState } from '../types/index'

export function mapStateToProps(state: IStoreState): { error: { message: string } } {
  return {
    error: state.errors
  }
}

export default connect(mapStateToProps)(ErrorBar)



// WEBPACK FOOTER //
// ./src/containers/ErrorBar.tsx